import Accounting from 'accounting';

export default {
    customTooltips(tooltip) {
        let tooltipEl = document.getElementById('chartjs-tooltip');
        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = '<div></div>';
            this._chart.canvas.parentNode.appendChild(tooltipEl);
        }
        if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
        }
        tooltip.displayColors = false;
        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltip.yAlign) {
            tooltipEl.classList.add(tooltip.yAlign);
        } else {
            tooltipEl.classList.add('no-transform');
        }

        function getBody(bodyItem) {
            return bodyItem.lines;
        }
        // Set Text
        if (tooltip.body) {
            let innerHtml = '';
            const titleLines = tooltip.title || [];
            const bodyLines = tooltip.body.map(getBody);
            titleLines.forEach((title) => {
                innerHtml += `<label>${title}</label>`;
            });
            bodyLines.forEach((body) => {
                const bodaySplit = body[0].split(':');
                const labelSplit = bodaySplit[0].split('$');

                innerHtml += `<label>${labelSplit[0]}<span> $${Accounting.formatNumber(labelSplit[1])}</span></label>`;
                innerHtml += `<h3>${bodaySplit[1]}%</h3>`;
            });
            const tableRoot = tooltipEl.querySelector('div');
            tableRoot.innerHTML = innerHtml;
        }
        const positionY = this._chart.canvas.offsetTop;
        const positionX = this._chart.canvas.offsetLeft;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
        tooltipEl.style.top = `${positionY - 102 + tooltip.caretY}px`;
        tooltipEl.style.height = '100px';
    },
};
